import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import Filter from "../../../Assets/Images/CommanImages/filter.png";
import columnaddition from "../../../Assets/Images/CommanImages/rectangleplus.png";
import updown from "../../../Assets/Images/CommanImages/updown.png";
import searchicon from "../../../Assets/Images/CommanImages/searchyellow.png";
import leftArrow from "../../../Assets/Images/CommanImages/Larrowbar.png";
import rightArrow from "../../../Assets/Images/CommanImages/Rarrowbar.png";
import FileExport from "../../../Assets/Images/CommanImages/fileexport.png";
import InterogativeImg from "./../../../Assets/Images/CommanImages/Warning.png";
import SelectedValuesDropdown from "../../../Components/Shared/SelectedValuesDropdown/SelectDropdown";
import FileSaver from "file-saver";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { FULL_API_BASE_URL } from "../../../Config/Config";
import Latex from "react-latex";
import "katex/dist/katex.min.css";
import he from "he";
import ReviewerDashboardTable from "./ReviewerDashboardTable";

const ReviewerQuesPaperDashboard = ({
  setMessageBox,
  setIsMessageBoxVisible,
  setActiveImg,
  dataClient,
  setPagePath,
  setNoTimeSet,
}) => {
  const [reportDashboardData, setReportDashboardData] = useState([]);
  const navigate = useNavigate();
  const accessToken = localStorage.getItem("other");
  const [headers, setHeaders] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (dataClient) {
      fetchDashboardData();
    }
  }, [dataClient]);

  const renderQuestionText = (questionText) => {
    const decodedQuestion = he.decode(questionText);
    const questionSegments = decodedQuestion.split(/(imgsrc=[^ ]+)/g);
    return questionSegments.map((segment, index) => {
      if (segment.startsWith("imgsrc=")) {
        const imageUrl = segment.replace("imgsrc=", "");
        return (
          <img
            key={index}
            src={imageUrl}
            alt={`Question Image ${index}`}
            style={{ width: "30px", height: "auto", margin: "5px" }}
          />
        );
      } else {
        return (
          <span key={index} className="truncated-text-2">
            <Latex>{segment}</Latex>
          </span>
        );
      }
    });
  };

  const userId = dataClient?.client_schema_name?.[6]?.[0]?.user_id;
  const clientBranchId =
    dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id;

  //  const fetchDashboardData = async () => {
  //     try {
  //         let url = `${FULL_API_BASE_URL}/get-reviewer-dashboard-details?user_id=${userId}`;
  //         if (clientBranchId) {
  //         url += `&client_branch_id=${clientBranchId}`;
  //         }

  //         const response = await fetch(url, {
  //         method: "GET",
  //         headers: {
  //             Authorization: `Bearer ${accessToken}`,
  //             "Content-Type": "application/json",
  //         },
  //         });

  //         if (!response.ok) {
  //         throw new Error("Failed to fetch dashboard data.");
  //         }

  //         const result = await response.json();

  //         const tableData = result || [];
  //         const headers = tableData[0] || [];
  //         const rows = tableData.slice(1) || [];

  //         const formattedHeaders = headers.map((header) =>
  //         header.replace(/^t\*/, "")
  //         );

  //         const transformedRows = rows.map((row) =>
  //         row.map((cell, index) => {
  //             const header = headers[index];
  //             if (["Assigned On", "Due Date"].includes(header)) {
  //             if (!cell) return "---";
  //             try {
  //                 const date = new Date(cell);
  //                 return date.toLocaleDateString("en-IN", {
  //                 year: "numeric",
  //                 month: "short",
  //                 day: "2-digit",
  //                 hour: "2-digit",
  //                 minute: "2-digit",
  //                 });
  //             } catch {
  //                 return cell;
  //             }
  //             }

  //             return cell === "" || cell === null || cell === undefined ? "---" : cell;
  //         })
  //         );

  //         setHeaders(formattedHeaders);
  //         setReportDashboardData(transformedRows);
  //     } catch (error) {
  //         console.error("Error fetching dashboard data:", error);
  //     }
  //   };

  const fetchDashboardData = async () => {
    setNoTimeSet(true);
    setIsLoading(true);
    setIsMessageBoxVisible(true);
    setMessageBox(
      <div className="Container-messageBOX">
        <div className="messagebox-insider1">
          <div className="loader-tc"></div>
          <span style={{ marginLeft: "10px", marginTop: "3px" }}>
            Loading data, please wait...
          </span>
        </div>
      </div>
    );
    setActiveImg(false);
    const slowLoadingTimer = setTimeout(() => {
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span style={{ marginLeft: "10px", marginTop: "3px" }}>
              This is taking longer than usual, please wait a moment...
            </span>
          </div>
        </div>
      );
    }, 5000);

    try {
      let url = `${FULL_API_BASE_URL}/get-reviewer-dashboard-details?user_id=${userId}`;
      if (clientBranchId) {
        url += `&client_branch_id=${clientBranchId}`;
      }

      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch dashboard data.");
      }

      const result = await response.json();

      // ✅ Handle object response with status 200 and a message (no data case)
      if (
        result &&
        typeof result === "object" &&
        !Array.isArray(result) &&
        result.status === 200
      ) {
        setHeaders([]);
        setReportDashboardData([]);
        clearTimeout(slowLoadingTimer);
        setIsLoading(false);
        setNoTimeSet(false);
        setIsMessageBoxVisible(true);
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <span style={{ marginLeft: "10px", marginTop: "3px" }}>
                {result.message || "No data available."}
              </span>
            </div>
          </div>
        );
        return;
      }

      const tableData = Array.isArray(result) ? result : [];
      const headers = tableData[0] || [];
      const rows = tableData.slice(1) || [];

      const formattedHeaders = headers.map((header) =>
        header.replace(/^t\*/, "")
      );

      const transformedRows = rows.map((row) =>
        row.map((cell, index) => {
          const header = headers[index];
          if (["Assigned On", "Due Date"].includes(header)) {
            if (!cell) return "---";
            try {
              const date = new Date(cell);
              return date.toLocaleDateString("en-IN", {
                year: "numeric",
                month: "short",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
              });
            } catch {
              return cell;
            }
          }
          return cell === "" || cell === null || cell === undefined
            ? "---"
            : cell;
        })
      );

      setHeaders(formattedHeaders);
      setReportDashboardData(transformedRows);

      clearTimeout(slowLoadingTimer);
      setIsLoading(false);
      setNoTimeSet(false);
      setIsMessageBoxVisible(false);
    } catch (error) {
      clearTimeout(slowLoadingTimer);
      setIsLoading(false);
      setNoTimeSet(false);
      setIsMessageBoxVisible(true);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <span style={{ marginLeft: "10px", marginTop: "3px" }}>
              {error.message}
            </span>
          </div>
        </div>
      );
      console.error("Error fetching dashboard data:", error);
    }
  };

  return (
    <div
      style={{
        height: "auto",
        width: "100%",
        paddingLeft: "37px",
        marginBottom: "40px",
      }}
    >
      <div className="">
        <div
          // className="create-role-container-ques-dashboards"
          style={{
            backgroundColor: "white",
            display: "flex",
            justifyContent: "space-between",
            zIndex: 1001,
            top: 0,
          }}
        >
          <p style={{ color: "#2F2E40", fontSize: "30px" }}>
            Reviewer Question Paper Dashboard
          </p>
          <div style={{ display: "flex" }}></div>
        </div>
        <p style={{ marginTop: "1%", color: "#2F2E40" }}>
          Select the already created question paper.
        </p>
        <div>
          <ReviewerDashboardTable
            headers={headers}
            data={reportDashboardData}
            searchPlaceholder="Filter Question Papers..."
            dataClient={dataClient}
            setPagePath={setPagePath}
            renderQuestionText={renderQuestionText}
            selectedRows={selectedRows}
            setSelectedRows={setSelectedRows}
            bulk={false}
          />
        </div>
      </div>
    </div>
  );
};

export default ReviewerQuesPaperDashboard;
